import styled, { css } from 'styled-components';

const spin = css`
	animation: export-progress-spin 1.1s linear infinite;

	@keyframes export-progress-spin {
		to {
			transform: rotate(360deg);
		}
	}
`;

export const StyledExportProgress = styled.div<{ $indeterminate: boolean }>`
	height: 20px;
	width: 20px;
	flex-shrink: 0;

	${({ $indeterminate }) => ($indeterminate ? spin : '')}
`;
